
/**
 * 
 * @param {*} props 
 */
const BandeauTitle = (props) => {
    return (
        <>
            <div className="row container-fluid bandeau">
                <div style={{ textAlign: "center" }} className="col-sm-2 col-md-2 bandeau__image">
                    <img src={require(`../../../assets/images/SVG/${props.image}`)} alt=""></img>
                </div>
                <div className="col-sm-10 col-md-10 text-left bandeau__bloc">
                    <h1 className="large-text large-font small-height text-uppercase" style={props.style}>{props.title}</h1>
                    <p className="step1_content">{props.subTitle}</p>
                </div>
            </div>
            <div className="row container-fluid footer-title">
                <div style={{ textAlign: "left" }} className="col-offset-7 col-5 step1_footer ">
                    {props.footerTitle}
                </div>
            </div>
        </>
    )
}
/**
 * 
 * @param {*} props 
 */
const BandeauContent = (props) => {
    return (
        <>
            <div className="row container-fluid bandeau-content">
                <div className="row bandeau-content__title">
                    <div className="col-1 col-md-1"></div><div className="col-11 text-left"><h2 className="text-uppercase" style={props.titles[0].style}>{props.titles[0].title}</h2></div>
                </div>
                <div className="row bandeau-content__title">
                    <div className="col-1 col-md-1"></div><div className="col-11 text-left"><h1 className="text-uppercase" style={props.titles[1].style}>{props.titles[1].title}</h1></div>
                </div>
                <div className="row bandeau-content__bloc">
                    <div className="col-md-12 col-lg-7 col-xl-7 text-right">
                        <div style={{ marginRight: "30px" }}>
                            <img src={require(`../../../assets/images/PNG/${props.image}`)} alt=""></img>
                        </div>
                        <div style={{ marginRight: "30px", paddingRight: "70px" }} className="--round-point">
                            <img src={require(`../../../assets/images/SVG/${props.point[0]}`)} alt=""></img>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-5 col-xl-5">
                        <div className="paraph" style={props.paraph.style} dangerouslySetInnerHTML={{ __html: props.paraph ? props.paraph.content : '' }}>
                        </div>
                        <ul id={props.check} style={props.listChek.style}>
                            {
                                props.listChek.list.map((content, index) => { return (<li key={index} dangerouslySetInnerHTML={{ __html: content }} ></li>) })
                            }
                        </ul>
                    </div>
                    <div className="col-md-12 col-lg-7 col-xl-7 text-right">
                        <div style={{ marginRight: "30px", paddingRight: "75px" }} className="--round-point--mobile">
                            <img src={require(`../../../assets/images/SVG/${props.point[1]}`)} alt=""></img>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

/**
 * 
 * @param {*} props 
 */
export const Bandeau = (props) => {
    return (
        <>
            <BandeauTitle
                title={props.content.bandTitle.title}
                subTitle={props.content.bandTitle.subTitle}
                footerTitle={props.content.bandTitle.footerTitle}
                style={props.content.bandTitle.style}
                image={props.content.bandTitle.image}
            />
            {
                props.content.bandContents.map((el, index) => (
                    <BandeauContent
                        key={index}
                        titles={el.titles}
                        image={el.image}
                        paraph={el.paraph}
                        listChek={el.listCheck}
                        check={props.content.id}
                        point={props.content.image}
                    />))
            }
        </>
    )
}